import List from './list.vue';
import Full from '@rebuild/materials/shared/report/Full.vue';
import Detail from '@rebuild/materials/shared/report/Detail.vue';

export const componentMap = {
	list: List,
	full: Full,
	detail: Detail
};
